export default __webpack_public_path__ + "static/media/check-circle.1c8d0b5a.svg";